<template>
	<div v-if="isShow">
		<div class="end-time">
			<template v-if="!isExpired">
				<div class="end-time__title">
					{{ $t('messages.end_time') }}
				</div>
				<div class="end-time__counter">
					<div class="end-time__item">
						<div class="end-time__value">{{ days }}</div>
						<div class="end-time__descr">дни</div>
					</div>
					<div class="end-time__item">
						<div class="end-time__value">{{ hours }}</div>
						<div class="end-time__descr">часы</div>
					</div>
					<div class="end-time__item">
						<div class="end-time__value">{{ minutes }}</div>
						<div class="end-time__descr">минуты</div>
					</div>
					<div class="end-time__item">
						<div class="end-time__value">{{ seconds }}</div>
						<div class="end-time__descr">секунды</div>
					</div>
				</div>
			</template>
			<div v-else class="end-time__status">
				<span class="end-time__dot"></span>
				<p>Пробный период истёк</p>
			</div>
			<a @click="onBuyClick(isExpired ? 'expired_timer' : 'active_timer')" class="regular-btn end-time-btn" :class="{ 'end-time-btn--corner': isExpired }">Купить полный курс</a>
		</div>

		<section v-if="isShowPopup" class="counter-page j-counter-popup">
			<!-- FT-009: продающий блок курса для платёжного контекста LMS (дизайн лендинга: locked-hero + locked-card/about) -->
			<div v-if="paymentEligible" class="course-sale">
				<div class="course-sale__hero">
					<h2 class="course-sale__hero-title">Ваш пробный период подошёл к&nbsp;концу</h2>
					<p class="course-sale__hero-lead">Надеемся, вы успели оценить курс. Откройте полный доступ, чтобы продолжить обучение и&nbsp;получить все материалы.</p>
				</div>

				<section class="course-sale__about">
					<div class="course-sale__about-l">
						<div class="course-sale__kicker">Онлайн-курс</div>
						<h3 class="course-sale__title">{{ productInfo ? productInfo.course_name : 'Полный доступ к курсу' }}</h3>
						<div class="course-sale__tag">
							<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
								<line x1="5" y1="12" x2="19" y2="12"></line>
								<polyline points="12 5 19 12 12 19"></polyline>
							</svg>
							<span>{{ productInfo ? productInfo.product_description : 'Откройте полный доступ к курсу и продолжите обучение в удобном темпе.' }}</span>
						</div>
						<div v-if="productInfo" class="course-sale__meta">
							<span v-if="productInfo.installment_period_months" class="course-sale__chip">
								<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line></svg>
								Рассрочка {{ productInfo.installment_period_months }}&nbsp;месяцев
							</span>
							<span class="course-sale__chip">
								<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12 7 12 12 15 14"></polyline></svg>
								Онлайн, в&nbsp;своём темпе
							</span>
							<span class="course-sale__chip course-sale__chip--green">
								<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
								Доступ навсегда
							</span>
						</div>
					</div>

					<aside class="course-sale__offer">
						<template v-if="productInfo">
							<div class="course-sale__offer-tag">
								<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15 9 22 9.3 16.5 14 18.5 21 12 17 5.5 21 7.5 14 2 9.3 9 9 12 2"></polygon></svg>
								Полный доступ
							</div>

							<div class="course-sale__price">
								<div class="course-sale__price-top">
									<template v-if="productInfo.installment_discounted_price">
										<div class="course-sale__price-now">{{ formatPrice(productInfo.installment_discounted_price) }} ₽<small>/мес</small></div>
										<div v-if="productInfo.installment_price > productInfo.installment_discounted_price" class="course-sale__price-old">{{ formatPrice(productInfo.installment_price) }} ₽/мес</div>
									</template>
									<template v-else>
										<div class="course-sale__price-now">{{ formatPrice(productInfo.full_discounted_price) }} ₽</div>
										<div v-if="productInfo.full_price > productInfo.full_discounted_price" class="course-sale__price-old">{{ formatPrice(productInfo.full_price) }} ₽</div>
									</template>
									<div v-if="productInfo.discount" class="course-sale__badge-off">−{{ discountPercent() }}%</div>
								</div>
								<p v-if="productInfo.installment_discounted_price" class="course-sale__price-sub"><b>0% переплат</b> · рассрочка на {{ productInfo.installment_period_months }}&nbsp;месяцев</p>
								<div v-if="productInfo.installment_discounted_price && productInfo.full_discounted_price" class="course-sale__price-inst">
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line></svg>
									<span>или <b>{{ formatPrice(productInfo.full_discounted_price) }} ₽</b> при оплате сразу<template v-if="productInfo.full_savings"> · выгода <b class="course-sale__g">{{ formatPrice(productInfo.full_savings) }} ₽</b></template></span>
								</div>
							</div>
						</template>

						<button type="button" @click="onBuyClick('expired_timer')" class="course-sale__btn">
							Купить полный курс
							<span class="course-sale__btn-arrow">
								<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
							</span>
						</button>

						<div class="course-sale__offer-foot">
							<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
							<span>Оплата картой или в&nbsp;рассрочку</span>
						</div>
					</aside>
				</section>
			</div>

			<div v-else class="counter-page__start">
				<img  class="counter-page__logo" src="../../../static/images/app-logo/eduson-academy-logo.svg" width="110" height="46" alt="Академия Эдюсон">
				<h2 class="counter-page__title">Ваш пробный период подошёл к&nbsp;концу</h2>
				<p class="counter-page__text">
					Надеемся, вы успели получить полезные знания и навыки за эти несколько дней.
					Приглашаем вас продолжить обучение на нашей программе. Нажмите на&nbsp;кнопку, чтобы получить полный доступ к&nbsp;курсу.
				</p>
				<div class="mt-30 text-center">
					<a @click="onBuyClick('expired_timer')" class="large-btn action-btn">Продолжить обучение</a>
					<div class="small-font-size mt-15">
						При приобретении полного доступа к курсу, <br>пожалуйста, <a :href="logout_path" data-method="delete" rel="nofollow">выйдите</a> из текущей сессии
					</div>
				</div>
			</div>
			<div class="counter-page__main">
				<div v-if="grouped_companies" class="counter-courses">
					<h2 class="counter-courses__title">Мои курсы</h2>

					<div class="counter-courses__holder">
						<div v-if="grouped_companies.paid" class="counter-courses__section j-section-courses">
							<h3 class="counter-courses__toggler" role="button" tabindex="0" @click="toggleShowSection">Оплаченные курсы</h3>
							<div class="counter-courses__content">
								<ul>
									<li v-for="course in grouped_companies.paid" class="counter-courses__item" :class="{ 'is-current': course.is_current }">
										<a :href="course.auto_login_url" class="counter-courses__link">{{ course.name }}</a>
									</li>
								</ul>
							</div>
						</div>

						<div v-if="grouped_companies.demo" class="counter-courses__section j-section-courses">
							<h3 class="counter-courses__toggler" role="button" tabindex="0" @click="toggleShowSection">Демонстрационные версии курсов</h3>
							<div class="counter-courses__content">
								<ul>
									<li v-for="course in grouped_companies.demo" class="counter-courses__item" :class="{ 'is-current': course.is_current }">
										<a :href="course.auto_login_url" class="counter-courses__link">{{ course.name }}</a>
									</li>
								</ul>
							</div>
						</div>

						<div v-if="grouped_companies.free" class="counter-courses__section j-section-courses">
							<h3 class="counter-courses__toggler" role="button" tabindex="0" @click="toggleShowSection">Бесплатные курсы</h3>
							<div class="counter-courses__content">
								<ul>
									<li v-for="course in grouped_companies.free" class="counter-courses__item" :class="{ 'is-current': course.is_current }">
										<a :href="course.auto_login_url" class="counter-courses__link">{{ course.name }}</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- FT-009: intent-модалка (дизайн лендинга: m-left со сводкой/тогглом + m-right с формой) -->
		<div v-if="showIntentModal" class="modal modal--payment-intent j-popup showing">
			<div class="modal__card pi" :class="{ 'pi--done': intentDone }">
				<button class="remove-btn modal__close pi__close" aria-label="Закрыть" @click="closeIntent"></button>

				<template v-if="!intentDone">
					<!-- ЛЕВО: курс, что входит, переключатель рассрочка/полностью, сводка цены -->
					<div class="pi__left">
						<div class="pi__kicker">Онлайн-курс</div>
						<h3 class="pi__course">{{ productInfo ? productInfo.course_name : 'Полный доступ к курсу' }}</h3>

						<ul class="pi__incl">
							<li>
								<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
								Полный доступ ко всем модулям и обновлениям
							</li>
							<li>
								<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
								Онлайн-обучение в удобном темпе
							</li>
							<li>
								<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
								Доступ к материалам навсегда
							</li>
						</ul>

						<template v-if="productInfo">
							<div class="pi__seg">
								<button type="button" :class="{ 'is-on': payMode === 'installment' }" @click="payMode = 'installment'">
									В рассрочку
									<small>0% · {{ productInfo.installment_period_months }} мес</small>
								</button>
								<button type="button" :class="{ 'is-on': payMode === 'full' }" @click="payMode = 'full'">
									Полностью
									<small>одним платежом</small>
								</button>
							</div>

							<div class="pi__price">
								<template v-if="payMode === 'installment'">
									<div class="pi__price-row">
										<span class="pi__lbl">Ежемесячный платёж</span>
										<span v-if="productInfo.installment_price > productInfo.installment_discounted_price" class="pi__old">{{ formatPrice(productInfo.installment_price) }} ₽/мес</span>
									</div>
									<div class="pi__price-row">
										<span class="pi__big">{{ formatPrice(productInfo.installment_discounted_price) }} ₽<small>/мес</small></span>
										<span v-if="productInfo.discount" class="pi__off">−{{ discountPercent() }}%</span>
									</div>
								</template>
								<template v-else>
									<div class="pi__price-row">
										<span class="pi__lbl">Полная стоимость</span>
										<span v-if="productInfo.full_price > productInfo.full_discounted_price" class="pi__old">{{ formatPrice(productInfo.full_price) }} ₽</span>
									</div>
									<div class="pi__price-row">
										<span class="pi__big">{{ formatPrice(productInfo.full_discounted_price) }} ₽</span>
										<span v-if="productInfo.discount" class="pi__off">−{{ discountPercent() }}%</span>
									</div>
								</template>
								<div v-if="productInfo.full_savings" class="pi__save">Выгода {{ formatPrice(productInfo.full_savings) }} ₽</div>
							</div>
						</template>
					</div>

					<!-- ПРАВО: форма с prefill + кнопки -->
					<div class="pi__right">
						<h2 class="pi__title">Получить полный доступ</h2>
						<p class="pi__sub">Оплатите онлайн картой или в&nbsp;рассрочку, либо закажите бесплатную консультацию.</p>

						<div class="pi__field">
							<label>Имя</label>
							<input v-model.trim="form.name" type="text" placeholder="Как к вам обращаться" :class="{ 'is-invalid': errors.name }">
							<span v-if="errors.name" class="pi__error">{{ errors.name }}</span>
						</div>
						<div class="pi__field">
							<label>Телефон</label>
							<input v-model.trim="form.phone" type="tel" placeholder="+7 (___) ___-__-__" :class="{ 'is-invalid': errors.phone }">
							<span v-if="errors.phone" class="pi__error">{{ errors.phone }}</span>
						</div>
						<div class="pi__field">
							<label>Email <span class="pi__optional">(необязательно)</span></label>
							<input v-model.trim="form.email" type="email" placeholder="you@email.com" :class="{ 'is-invalid': errors.email }">
							<span v-if="errors.email" class="pi__error">{{ errors.email }}</span>
						</div>

						<label class="pi__consent">
							<input v-model="consent" type="checkbox">
							<span>Я&nbsp;соглашаюсь на&nbsp;обработку персональных данных</span>
						</label>
						<span v-if="errors.consent" class="pi__error">{{ errors.consent }}</span>

						<div class="pi__actions">
							<button type="button" class="pi__btn pi__btn--primary" @click="startPayment">
								{{ payButtonLabel }}
								<span class="pi__btn-arrow">
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
								</span>
							</button>
							<button type="button" class="pi__btn pi__btn--ghost" @click="startConsultation">Получить бесплатную консультацию</button>
						</div>

						<div class="pi__secure">
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
							Безопасная оплата · CloudPayments
						</div>
					</div>
				</template>

				<template v-else>
					<div class="pi__done">
						<h2 class="pi__title">Спасибо! Мы&nbsp;скоро свяжемся с&nbsp;вами</h2>
						<p class="pi__sub">Наш менеджер свяжется с&nbsp;вами по&nbsp;указанным контактам.</p>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import payWithUserPayload, { loadProduct } from "../../common/cloud-payments.js";

export default {
	name: 'Counter',

	props: {
		current_user_created_at: {
			type: String,
			required: true
		},
		counter_days: {
			type: Number,
			default: 7
		},
		start_action_day: {
			type: String,
			default: ''
		},
		current_company: {
			type: String,
			required: true
		},
		logout_path: {
			type: String,
			required: true
		},
		events_url: {
			type: String,
			required: true
		},
		current_user_id: {
			type: Number,
			required: false
		},
		current_company_id: {
			type: Number,
			required: false
		},
		user_prolong_demo_course_before: {
			type: String,
			required: false
		},
		grouped_companies: {
			type: Object,
			required: false
		},
		// FT-009: in-LMS платёжный сценарий free/demo Academy
		payment_enabled: {
			type: Boolean,
			default: false
		},
		paid_product_url: {
			type: String,
			default: ''
		},
		payment_public_id: {
			type: String,
			default: ''
		},
		prefill_name: {
			type: String,
			default: ''
		},
		prefill_phone: {
			type: String,
			default: ''
		},
		prefill_email: {
			type: String,
			default: ''
		},
		tracking_info: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},

	data() {
		return {
			MILLISECONDS_IN_DAY: 86400000,
			showIntentModal: false,
			intentDone: false,
			intentSource: '',
			consent: true,
			productInfo: null,
			payMode: 'installment',
			form: { name: '', phone: '', email: '' },
			errors: { name: '', phone: '', email: '', consent: '' },
			startActionDate: this.start_action_day ? this.getParseDate(this.start_action_day) : this.getParseDate(this.current_user_created_at),
			currentUserCreatedAt: this.getParseDate(this.current_user_created_at),
			endDate: '',
			counterDays: this.counter_days,
			isShow: true,
			isShowPopup: false,
			isExpired: false,
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0
		}
	},

	computed: {
		// FT-009: оплата доступна только при включённом флаге и заданном slug продукта.
		// Серверная граница (academy? && free_and_demo_pipeline) обеспечивается layout-гейтом и Company#payment_eligible?.
		paymentEligible() {
			return this.payment_enabled && !!this.paid_product_url;
		},

		// FT-009: подпись основной кнопки оплаты зависит от выбранного режима
		payButtonLabel() {
			return this.payMode === 'installment' ? 'Оформить рассрочку' : 'Оплатить полностью';
		}
	},

	created() {
		if (+this.currentUserCreatedAt.getTime() < +this.startActionDate.getTime()) {
			this.isShow = false;
			return;
		}

		// FT-009: для платёжного контекста подтягиваем данные продукта (цена/рассрочка/описание)
		// из prices.json для продающего блока paywall.
		if (this.paymentEligible) {
			this.fetchProduct();
		}

		this.endDate = this.user_prolong_demo_course_before
			? +this.getParseDate(this.user_prolong_demo_course_before).getTime()
			: +this.currentUserCreatedAt.getTime() + (this.counterDays * this.MILLISECONDS_IN_DAY);


		this.updateRemainingTime();

		if (this.getDifTime()) {
			setInterval(this.updateRemainingTime, 1000);
		}
	},

	methods: {
		// FT-009: подтягиваем продукт по slug; null при недоступности prices.json — блок цены просто не покажется
		async fetchProduct() {
			this.productInfo = await loadProduct(this.paid_product_url);
		},

		// Форматирование цены с разделением разрядов (ru-RU): 100000 -> "100 000"
		formatPrice(value) {
			return Number(value || 0).toLocaleString('ru-RU');
		},

		// discount хранится долей (0.6 = скидка 60%)
		discountPercent() {
			return this.productInfo ? Math.round(this.productInfo.discount * 100) : 0;
		},

		// FT-009: клик по CTA — открыть intent-модалку для eligible-контекста, иначе прежний внешний сценарий
		onBuyClick(source) {
			if (this.paymentEligible) {
				this.openIntent(source);
			} else {
				const eventName = source === 'expired_timer' ? 'request_full_course_timer_end' : 'request_full_course_buy_now';
				this.sendEvent('https://eduson.academy/platform-special', eventName);
			}
		},

		openIntent(source) {
			this.intentSource = source;
			this.intentDone = false;
			this.consent = true;
			this.payMode = 'installment';
			this.errors = { name: '', phone: '', email: '', consent: '' };
			this.form = { name: this.prefill_name || '', phone: this.prefill_phone || '', email: this.prefill_email || '' };
			this.showIntentModal = true;
		},

		closeIntent() {
			this.showIntentModal = false;
		},

		// CTR-05: name и phone обязательны, email опционален; невалид блокирует оба действия
		validate() {
			this.errors = { name: '', phone: '', email: '', consent: '' };
			let valid = true;
			if (!this.form.name) {
				this.errors.name = 'Укажите имя';
				valid = false;
			}
			if (!this.form.phone) {
				this.errors.phone = 'Укажите телефон';
				valid = false;
			} else if (!/^[0-9+\-()\s]+$/.test(this.form.phone) || !/[0-9]/.test(this.form.phone)) {
				this.errors.phone = 'Некорректный телефон';
				valid = false;
			}
			if (this.form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
				this.errors.email = 'Некорректный email';
				valid = false;
			}
			if (!this.consent) {
				this.errors.consent = 'Необходимо согласие на обработку персональных данных';
				valid = false;
			}
			return valid;
		},

		// CTR-02: минимальный attribution-набор + slug + контакты лида; tracking_info насквозь
		buildAttribution() {
			return {
				user_id: this.current_user_id,
				tracking_info: this.tracking_info,
				source_surface: this.intentSource,
				product_slug: this.paid_product_url,
				pay_mode: this.payMode,
				name: this.form.name,
				phone: this.form.phone,
				email: this.form.email
			};
		},

		sendAttributionEvent(eventName) {
			return axios.request({
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					"X-CSRF-Token": document
						.querySelector('meta[name="csrf-token"]')
						.getAttribute("content"),
				},
				url: this.events_url,
				method: "POST",
				data: {
					name: eventName,
					description: "Запрос из курса: " + this.current_company,
					user_id: this.current_user_id,
					eventable_type: "Company",
					eventable_id: this.current_company_id,
					source_surface: this.intentSource,
					product_slug: this.paid_product_url
				}
			});
		},

		// SOL-04 / CTR-02: оплата в рассрочку через единый бандл-модуль CloudPayments (publicId из ENV, EXT-01)
		async startPayment() {
			if (!this.validate()) return;
			const attribution = this.buildAttribution();
			this.sendAttributionEvent('request_full_course_payment');
			const result = await payWithUserPayload({
				publicId: this.payment_public_id,
				productSlug: this.paid_product_url,
				attribution,
				payMode: this.payMode
			});
			// FM-02: продукт/виджет недоступен — мягкий fallback на экран «спасибо»,
			// атрибуция запроса уже отправлена, менеджер свяжется с лидом.
			if (!result.ok) {
				this.intentDone = true;
			}
		},

		// SOL-06 / CTR-06: бесплатная консультация (доставка в n8n → Genezis/Sensei, EXT-03)
		startConsultation() {
			if (!this.validate()) return;
			this.sendAttributionEvent('request_full_course_consultation');
			this.intentDone = true;
		},

		getDifTime() {
			const currentTime = new Date();
			const difference = this.endDate - +currentTime.getTime();

			if (difference > 0) {
				return difference;
			}

			return false;
		},

		updateRemainingTime() {
			const difference = this.getDifTime();

			if (difference > 0) {
				this.days = Math.floor(difference / (1000 * 60 * 60 * 24));
				this.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				this.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
				this.seconds = Math.floor((difference % (1000 * 60)) / 1000);
			} else {
				this.isExpired = true;
				document.querySelector('.page-content').classList.add('hide');
				document.querySelector('#app-header').classList.add('hide');
				this.isShowPopup = true;
			}
		},

		getParseDate(stringOfDate) {
			const arr = stringOfDate.split(/[\-\+ :T]/);
			const date = new Date();

			date.setUTCFullYear(arr[0]);
			date.setUTCMonth(arr[1] - 1);
			date.setUTCDate(arr[2]);
			date.setUTCHours(arr[3]);
			date.setUTCMinutes(arr[4]);
			date.setUTCSeconds(arr[5]);

			return date;
		},

		sendEvent(redirect_url, event_name) {
			axios.request({
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					"X-CSRF-Token": document
						.querySelector('meta[name="csrf-token"]')
						.getAttribute("content"),
				},
				url: this.events_url,
				method: "POST",
				data: {
					name: event_name,
					description: "Запрос из курса: " + this.current_company,
					user_id: this.current_user_id,
					eventable_type: "Company",
					eventable_id: this.current_company_id,
					redirect_url: redirect_url
				}
			}).then((response) => {
				window.location.href = redirect_url;
			})
		},

		toggleShowSection(e) {
			e.target.closest('.j-section-courses').classList.toggle('is-open');
		}
	}
}
</script>

<style>
.counter-page {
	min-height: calc(100vh - 140px);
	padding-bottom: 80px;
	background-color: var(--white);
}

.counter-page__start {
	padding: 40px 0;
	margin-bottom: 40px;
	text-align: center;
}

.counter-page__logo {
	margin-bottom: 16px;
}

.counter-page__title {
	margin-bottom: 16px;
	font-size: 32px;
	line-height: 1.2;
	text-align: center;
	color: #0842a0;
}

.counter-page__text {
	max-width: 700px;
	margin: 0 auto;
	font-size: 18px;
	line-height: 1.4;
	text-align: center;
}

/* FT-009: продающий блок курса (paywall). Дизайн 1:1 из лендинга:
   locked-hero (центр) + locked-card = section.about (две колонки) с offer/price.
   Значения цвета/радиуса — литералы из :root лендинга. */
.course-sale {
	max-width: 1040px;
	margin: 0 auto;
	padding: 24px 0 8px;
}

.course-sale__hero {
	max-width: 680px;
	margin: 0 auto;
	text-align: center;
}

.course-sale__hero-title {
	margin: 0;
	font-size: 32px;
	font-weight: 800;
	letter-spacing: -0.02em;
	line-height: 1.1;
	color: #2c49ad;
}

.course-sale__hero-lead {
	margin: 14px auto 0;
	max-width: 560px;
	font-size: 17px;
	line-height: 1.55;
	color: #6e7990;
}

/* locked-card = .about (две колонки) */
.course-sale__about {
	display: grid;
	grid-template-columns: 1.2fr 0.8fr;
	gap: 36px;
	align-items: start;
	margin-top: 32px;
	padding: 40px;
	background: #fff;
	border: 1px solid #e6ecf4;
	border-radius: 24px;
	box-shadow: 0 2px 8px rgba(22, 33, 58, 0.06);
	text-align: left;
}

.course-sale__about-l {
	display: flex;
	flex-direction: column;
}

.course-sale__kicker {
	margin-bottom: 12px;
	font-size: 14px;
	font-weight: 700;
	letter-spacing: 0.02em;
	text-transform: uppercase;
	color: #97a1b5;
}

.course-sale__title {
	margin: 0;
	font-size: 32px;
	font-weight: 800;
	letter-spacing: -0.025em;
	line-height: 1.06;
	color: #15213b;
}

.course-sale__tag {
	display: flex;
	gap: 11px;
	margin-top: 18px;
	max-width: 52ch;
	font-size: 16px;
	line-height: 1.55;
	color: #3c4a66;
	white-space: pre-line;
}

.course-sale__tag svg {
	flex: none;
	margin-top: 4px;
	color: #6b4dff;
}

.course-sale__meta {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-top: 22px;
}

.course-sale__chip {
	display: inline-flex;
	align-items: center;
	gap: 7px;
	padding: 8px 13px;
	border-radius: 999px;
	background: #f4f7fb;
	border: 1px solid #e6ecf4;
	font-size: 13.5px;
	font-weight: 600;
	color: #3c4a66;
}

.course-sale__chip svg {
	flex: none;
	color: #6b4dff;
}

.course-sale__chip--green {
	background: #e5f6ee;
	border-color: #ccebdd;
	color: #0e7a50;
}

.course-sale__chip--green svg {
	color: #16a06a;
}

/* offer (правая колонка) */
.course-sale__offer {
	display: flex;
	flex-direction: column;
	padding: 24px;
	border-radius: 18px;
	background: linear-gradient(180deg, #f5f2ff, #fff 60%);
	border: 1px solid #e2d9ff;
	box-shadow: 0 12px 34px rgba(107, 77, 255, 0.14);
}

.course-sale__offer-tag {
	align-self: flex-start;
	display: inline-flex;
	align-items: center;
	gap: 7px;
	padding: 7px 12px;
	border-radius: 999px;
	background: #fff;
	border: 1px solid #e2d9ff;
	box-shadow: 0 2px 8px rgba(22, 33, 58, 0.06);
	font-size: 12.5px;
	font-weight: 800;
	letter-spacing: 0.03em;
	text-transform: uppercase;
	color: #5a3de6;
}

.course-sale__price {
	padding-top: 18px;
}

.course-sale__price-top {
	display: flex;
	align-items: baseline;
	gap: 14px;
	flex-wrap: wrap;
}

.course-sale__price-now {
	font-size: 40px;
	font-weight: 800;
	letter-spacing: -0.02em;
	color: #15213b;
}

.course-sale__price-now small {
	font-size: 21px;
	font-weight: 700;
	color: #6e7990;
}

.course-sale__price-old {
	font-size: 20px;
	font-weight: 600;
	color: #97a1b5;
	text-decoration: line-through;
}

.course-sale__badge-off {
	display: inline-flex;
	align-items: center;
	padding: 5px 11px;
	border-radius: 999px;
	background: #ffe3e0;
	color: #d83a2c;
	font-weight: 800;
	font-size: 13.5px;
}

.course-sale__price-sub {
	margin: 10px 0 0;
	font-size: 14.5px;
	color: #6e7990;
}

.course-sale__price-sub b {
	color: #5a3de6;
	font-weight: 800;
}

.course-sale__price-inst {
	margin-top: 14px;
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 12px 14px;
	border-radius: 12px;
	background: #fff;
	border: 1px solid #e6ecf4;
	font-size: 13.5px;
	font-weight: 600;
	line-height: 1.45;
	color: #6e7990;
}

.course-sale__price-inst svg {
	flex: none;
	margin-top: 1px;
	color: #6b4dff;
}

.course-sale__price-inst b {
	color: #15213b;
}

.course-sale__g {
	color: #16a06a;
}

.course-sale__btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 100%;
	margin-top: 20px;
	padding: 18px 30px;
	border: none;
	border-radius: 999px;
	appearance: none;
	-webkit-appearance: none;
	background: #6b4dff;
	color: #fff;
	font-weight: 800;
	font-size: 17px;
	box-shadow: 0 8px 22px rgba(107, 77, 255, 0.28);
	cursor: pointer;
	transition: transform 0.15s, box-shadow 0.15s, background 0.15s;
}

.course-sale__btn:hover {
	background: #5a3de6;
	color: #fff;
	box-shadow: 0 12px 28px rgba(107, 77, 255, 0.36);
}

.course-sale__btn:focus {
	outline: none;
}

.course-sale__btn:active {
	transform: translateY(1px);
}

.course-sale__btn-arrow {
	display: grid;
	place-items: center;
	width: 34px;
	height: 34px;
	border-radius: 50%;
	background: #fff;
	color: #6b4dff;
}

.course-sale__offer-foot {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin-top: 13px;
	font-size: 12.5px;
	color: #6e7990;
}

.course-sale__offer-foot svg {
	flex: none;
	color: #16a06a;
}

/* FT-009: отступ, чтобы блок «Мои курсы» не сливался с продающим блоком */
.counter-page__main {
	margin-top: 20px;
}

.counter-courses {
	width: 820px;
	margin: 0 auto;
}

.counter-courses__title {
	margin-bottom: 12px;
	font-size: 17px;
	font-weight: 700;
}

.counter-courses__section {
	&:not(:last-child) {
		border-bottom: 1px solid var(--dark-border-color);
	}

	&:last-child {
		.counter-courses__content {
			border-radius: 0 0 5px 5px;
		}
	}

	&.is-open {
		.counter-courses__toggler {
			&::after {
				transform: rotate(270deg);
			}
		}

		.counter-courses__content {
			display: block;
		}
	}
}

.counter-courses__holder {
	border: 1px solid var(--dark-border-color);
	border-radius: 5px;
	overflow: hidden;
}

.counter-courses__toggler {
	position: relative;
	padding: 16px 64px;
	border-radius: 5px 5px 0 0;
	font-size: 15px;
	font-weight: 700;
	cursor: pointer;

	&:hover {
		background-color: var(--middle-bg);
	}

	&::after {
		content: "";
		position: absolute;
		top: 20px;
		right: 44px;
		display: block;
		width: 10px;
		height: 10px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-image: var(--icon-arrow);
		transform: rotate(90deg);
		transition: 0.1s;
	}
}

.counter-courses__content {
	display: none;
	padding: 10px 0;
	background-color: hsl(var(--action-h), var(--action-s), 96%);
}

.counter-courses__item {
	&.is-current {
		.counter-courses__link {
			pointer-events: none;

			&::before {
				content: "";
				position: absolute;
				top: 18px;
				left: 40px;
				display: block;
				width: 6px;
				height: 6px;
				border-radius: 50%;
				background-color: var(--high);
			}
		}
	}
}

.counter-courses__link {
	position: relative;
	display: block;
	padding: 12px 64px;
	font-size: 15px;
	line-height: 1.3;
	color: var(--main-font);

	&:hover {
		background-color: hsl(var(--action-h), var(--action-s), 92%);
	}
}

.end-time {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 80px;
	padding: 10px 0;
	background-color: #8352ff;
	color: #fff;
	overflow: hidden;
}

.end-time .page-inner {
	display: flex;
	align-items: center;
	justify-content: center;
}

.end-time__title {
	font-size: 20px;
	line-height: 1.4;
	font-weight: 700;
	color: var(--white);
}

/* FT-009: статус «истёк» вместо нулей — стиль пилюли из дизайна лендинга (.hdr-status) */
.end-time__status {
	display: inline-flex;
	align-items: center;
	gap: 11px;
	padding: 11px 20px;
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.14);
	border: 1px solid rgba(255, 255, 255, 0.26);
	backdrop-filter: blur(6px);
}

.end-time__status p {
	margin: 0;
	font-size: 15px;
	font-weight: 700;
	color: var(--white);
	white-space: nowrap;
}

.end-time__dot {
	width: 9px;
	height: 9px;
	border-radius: 50%;
	background: #ffd7d2;
	box-shadow: 0 0 0 4px rgba(255, 215, 210, 0.25);
}

.end-time__counter {
	position: relative;
	display: flex;
	justify-content: center;
	gap: 5px 10px;
	margin-left: 160px;
	margin-right: 150px;
}

.end-time__counter::before {
	content: "";
	position: absolute;
	bottom: -11px;
	left: -120px;
	width: 109px;
	height: 80px;
	background-image: url(../../../static/images/counter/clock_3.png);
	background-position: left top;
	background-size: contain;
	background-repeat: no-repeat;
}

.end-time__counter::after {
	content: "";
	position: absolute;
	bottom: -11px;
	right: -160px;
	width: 177px;
	height: 80px;
	background-image: url(../../../static/images/counter/clock_4.png);
	background-position: left top;
	background-size: contain;
	background-repeat: no-repeat;
}

.end-time__item {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	min-width: 50px;
}

.end-time__value {
	display: block;
	width: 40px;
	height: 40px;
	padding: 8px 4px;
	border-radius: 5px;
	background-color: var(--white);
	color: var(--main-font);
	font-size: 24px;
	font-weight: 700;
	text-align: center;
}

.end-time__descr {
	margin-top: 4px;
	color: var(--white);
	font-size: 12px;
	font-weight: 400;
	text-align: center;
}

.end-time-btn {
	background-color: hsl(47, 100%, 62%);
	color: var(--main-font);
	border-radius: 16px;
	font-weight: 700;
}

.end-time-btn:hover {
	background-color: hsl(47, 100%, 52%);
	color: var(--main-font);
}

/* FT-009: в expired-состоянии кнопка уходит в правый угол, чтобы статус остался строго по центру */
.end-time-btn--corner {
	position: absolute;
	top: 50%;
	right: 32px;
	transform: translateY(-50%);
}

/* FT-009: intent-модалка (дизайн лендинга: m-left со сводкой/тогглом + m-right с формой) */
.modal--payment-intent .modal__card.pi {
	display: grid;
	grid-template-columns: 1fr 0.92fr;
	width: min(860px, 100%);
	max-width: 860px;
	padding: 0;
	overflow: hidden;
	border-radius: 26px;
}

.modal--payment-intent .modal__card.pi--done {
	grid-template-columns: 1fr;
	width: min(460px, 100%);
}

.pi__close {
	z-index: 5;
}

/* ЛЕВО */
.pi__left {
	display: flex;
	flex-direction: column;
	padding: 34px 32px;
	background: linear-gradient(180deg, #f5f2ff, #fff 70%);
	border-right: 1px solid #e6ecf4;
}

.pi__kicker {
	font-size: 12.5px;
	font-weight: 700;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: #6b4dff;
}

.pi__course {
	margin: 9px 0 0;
	font-size: 24px;
	font-weight: 800;
	letter-spacing: -0.02em;
	line-height: 1.12;
	color: #15213b;
}

.pi__incl {
	margin: 20px 0 0;
	padding: 0;
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: 11px;
}

.pi__incl li {
	display: flex;
	gap: 11px;
	align-items: flex-start;
	font-size: 14.5px;
	font-weight: 600;
	line-height: 1.4;
	color: #3c4a66;
}

.pi__incl li svg {
	flex: none;
	margin-top: 1px;
	color: #16a06a;
}

.pi__seg {
	display: flex;
	gap: 5px;
	margin-top: 22px;
	padding: 5px;
	background: #f4f7fb;
	border: 1px solid #e6ecf4;
	border-radius: 14px;
}

.pi__seg button {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2px;
	padding: 11px 8px;
	border: none;
	border-radius: 10px;
	background: transparent;
	font-weight: 700;
	font-size: 13.5px;
	color: #6e7990;
	cursor: pointer;
	transition: 0.18s;
}

.pi__seg button small {
	font-size: 11px;
	font-weight: 600;
	color: #97a1b5;
}

.pi__seg button.is-on {
	background: #fff;
	color: #15213b;
	box-shadow: 0 2px 8px rgba(22, 33, 58, 0.06);
}

.pi__seg button.is-on small {
	color: #5a3de6;
}

.pi__price {
	margin-top: 20px;
	padding-top: 18px;
	border-top: 1px dashed #e6ecf4;
}

.pi__price-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.pi__price-row + .pi__price-row {
	margin-top: 4px;
}

.pi__lbl {
	font-size: 14px;
	color: #6e7990;
}

.pi__old {
	font-size: 15px;
	color: #97a1b5;
	text-decoration: line-through;
}

.pi__big {
	font-size: 32px;
	font-weight: 800;
	letter-spacing: -0.02em;
	color: #15213b;
}

.pi__big small {
	font-size: 16px;
	font-weight: 700;
	color: #6e7990;
}

.pi__off {
	font-size: 12.5px;
	font-weight: 800;
	color: #d83a2c;
	background: #ffe3e0;
	padding: 4px 10px;
	border-radius: 999px;
}

.pi__save {
	align-self: flex-start;
	margin-top: 8px;
	display: inline-flex;
	padding: 5px 11px;
	border-radius: 99px;
	background: #e5f6ee;
	font-size: 13.5px;
	font-weight: 700;
	color: #16a06a;
}

/* ПРАВО */
.pi__right {
	display: flex;
	flex-direction: column;
	padding: 34px 32px;
}

.pi__title {
	margin: 0;
	font-size: 18px;
	font-weight: 800;
	color: #15213b;
}

.pi__sub {
	margin: 5px 0 0;
	font-size: 14px;
	line-height: 1.45;
	color: #6e7990;
}

.pi__field {
	margin-top: 15px;
}

.pi__field label {
	display: block;
	margin-bottom: 7px;
	font-size: 13px;
	font-weight: 700;
	color: #3c4a66;
}

.pi__optional {
	color: #97a1b5;
	font-weight: 600;
}

.pi__field input {
	display: block;
	width: 100%;
	height: 50px;
	padding: 0 16px;
	border: 1.5px solid #e6ecf4;
	border-radius: 13px;
	background: #f4f7fb;
	font-family: inherit;
	font-size: 15.5px;
	color: #15213b;
	transition: 0.15s;
}

.pi__field input::placeholder {
	color: #97a1b5;
}

.pi__field input:focus {
	outline: none;
	border-color: #6b4dff;
	background: #fff;
	box-shadow: 0 0 0 4px rgba(107, 77, 255, 0.12);
}

.pi__field input.is-invalid {
	border-color: #d83a2c;
}

.pi__error {
	display: block;
	margin-top: 6px;
	font-size: 13px;
	color: #d83a2c;
}

.pi__consent {
	display: flex;
	gap: 10px;
	align-items: flex-start;
	margin-top: 15px;
	font-size: 12.5px;
	line-height: 1.4;
	color: #6e7990;
	cursor: pointer;
}

.pi__consent input {
	flex: none;
	width: 18px;
	height: 18px;
	margin-top: 1px;
	accent-color: #6b4dff;
	cursor: pointer;
}

.pi__actions {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 18px;
}

.pi__btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 100%;
	padding: 16px 24px;
	border: none;
	border-radius: 999px;
	appearance: none;
	-webkit-appearance: none;
	font-weight: 800;
	font-size: 16px;
	cursor: pointer;
	transition: transform 0.15s, box-shadow 0.15s, background 0.15s;
}

.pi__btn:focus {
	outline: none;
}

.pi__btn:active {
	transform: translateY(1px);
}

.pi__btn--primary {
	background: #6b4dff;
	color: #fff;
	box-shadow: 0 8px 22px rgba(107, 77, 255, 0.28);
}

.pi__btn--primary:hover {
	background: #5a3de6;
	color: #fff;
}

.pi__btn--ghost {
	background: #fff;
	color: #5a3de6;
	border: 1.5px solid #dad0ff;
}

.pi__btn--ghost:hover {
	background: #f5f2ff;
	border-color: #6b4dff;
}

.pi__btn-arrow {
	display: grid;
	place-items: center;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background: #fff;
	color: #6b4dff;
}

.pi__secure {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin-top: 14px;
	font-size: 12.5px;
	color: #97a1b5;
}

.pi__secure svg {
	flex: none;
	color: #16a06a;
}

.pi__done {
	padding: 48px 40px;
	text-align: center;
}

.pi__done .pi__title {
	font-size: 24px;
}

.pi__done .pi__sub {
	margin-top: 10px;
}
</style>
